import { Component, Input } from '@angular/core';

@Component({
  selector: 'novatiq-tab',
  templateUrl: './novatiq-tab.component.html',
  host: {
    '[hidden]': '!active',
    'class': 'min-h-0'
  }
})
export class NovatiqTabComponent {
  @Input() tabTitle: string;
  @Input() active = false;
}
